import { Tag, TagType } from '../../../../../../_models/Tag';
import { BackpackItem, BackpackItemType } from './types';
import {
  Polygon,
  PolygonAction,
  PolygonActionType,
} from '../../../../../../_models/virtualStaging/Polygon';
import {
  ContentType,
  GameCondition,
  GameLock,
  LOCK_SOLUTION_SEPARATOR,
} from '../../../../../../_models/Game';

export const transformTagToBackpackItem = (item: Tag, tourId: number): BackpackItem => {
  let preview: string;

  switch (item.type) {
    case TagType.Iframe:
      preview = '/experience/iframe.svg';
      break;
    // case TagType.Image:
    //   preview = `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/tags/${item.url}`;
    //   break;
    case TagType.Music:
      preview = '/experience/music.svg';
      break;
    // case TagType.Video:
    //   preview = '/experience/video.svg';
    //   break;
    default:
      preview = '/experience/notFound.png';
  }

  return {
    id: item.id,
    preview,
    title: item.title,
    type: BackpackItemType.Tag,
    origin: item,
  };
};

export const transformPolygonToBackpackItem = (item: Polygon, tourId: number): BackpackItem => {
  let preview: string;
  const action: PolygonAction = item.polygonsActions.find((i) => i.gameBackpack);
  switch (action.type) {
    case PolygonActionType.Iframe:
      preview = '/experience/iframe.svg';
      break;
    case PolygonActionType.Image:
      preview = `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/polygons/${action.url}`;
      break;
    case PolygonActionType.Music:
      preview = '/experience/music.svg';
      break;
    case PolygonActionType.Video:
      preview = '/experience/video.svg';
      break;
    default:
      preview = '/experience/polygon.svg';
  }

  return {
    id: item.id,
    preview,
    title: item.title,
    type: BackpackItemType.Polygon,
    origin: action,
  };
};

export const transformConditionToBackpackItem = (
  item: GameCondition,
  gameId: number,
  conditionId: number,
): BackpackItem => {
  let preview: string;
  switch (item.content_type) {
    case ContentType.Text:
      preview = '/experience/text.svg';
      break;
    case ContentType.Picture:
      preview = `${process.env.NEXT_PUBLIC_CDN}/games/${gameId}/conditions/${conditionId}/${item.content_value}`;
      break;
    case ContentType.ExperiencePopupImage:
      preview = `${process.env.NEXT_PUBLIC_CDN}/games/${gameId}/conditions/${conditionId}/${item.content_value}`;
      break;
    case ContentType.Sound:
      preview = '/experience/music.svg';
      break;
    case ContentType.Video:
      preview = '/experience/video.svg';
      break;
    case ContentType.ExperiencePopupVideo:
      preview = `${process.env.NEXT_PUBLIC_CDN}/games/${gameId}/conditions/${conditionId}/${item.content_value}`;
      break;
    default:
      preview = '/experience/notFound.svg';
  }

  return {
    id: item.id,
    preview,
    title: item.name,
    type: BackpackItemType.Condition,
    origin: item,
  };
};

export const transformCollectItemsToBackpackItem = (
  item: GameLock & { count: number },
  gameId: number,
): BackpackItem => {
  const collectItems = item.solution.split(LOCK_SOLUTION_SEPARATOR).length;
  return {
    id: item.id,
    preview: item.icon
      ? `${process.env.NEXT_PUBLIC_CDN}/games/${gameId}/locks/${item.id}/${item.icon}`
      : '/experience/puzzle.svg',
    title: collectItems === 1 ? `${item.name}` : `${item.name} ${item.count} of ${collectItems}`,
    type: BackpackItemType.CollectItem,
    origin: item,
  };
};
